import {
  Button,
  Flex,
  Grid,
  Heading,
  Stack,
  Text
} from '@chakra-ui/react'
import { useState } from 'react'

import { Loading } from '@/components/Loading'
import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import {
  OffersVehicleProvider
} from '@/context/OffersVehicleProvider'
import { WizzardHeaderProvider } from '@/context/WizzardHeaderContext'
import { useInvokeBmw } from '@/hooks/useOffer'
import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'
import { LeasingPageComponent } from './leasing'

function LeasingPageWrapper() {
  const { isLoadingData, insuranceParams, insuranceParamsId, isContracted } = useInsuranceParams()
  const { translate, translateFormat } = useTranslationsContext()
  const [isGoingBack, setIsGoingBack] = useState(false)
  const { mutateAsync: invokeBmw } = useInvokeBmw()

  return (
    <>
      {isLoadingData && <Loading large={true} />}
      {!isLoadingData && (
        <WizzardHeaderProvider>
          <OffersVehicleProvider>

            {isContracted && (
              <Section>
                <Container>
                  <Grid
                    sx={{
                      justifyContent: 'center',
                      alignItems: 'center',
                      textAlign: 'center',
                    }}
                  >
                    <Heading
                      sx={{ fontSize: '2xl', fontWeight: 'medium' }}
                      as="h2"
                    >
                      <Stack alignItems="center">
                        <Flex>
                          {translateFormat('contractWasAlreadyClosed', `Smlouva č. ${insuranceParams?.generalParams.contractNumber} byla již uzavřena.`, { contractNumber: <Text mx={2} fontWeight="bold">{insuranceParams?.generalParams.contractNumber}</Text> })}
                        </Flex>

                        <Flex>
                          <Button
                            colorScheme="red"
                            type="submit"
                            isLoading={isGoingBack}
                            onClick={() => {
                              setIsGoingBack(true)
                              invokeBmw({
                                action: 'Cancel',
                                paramsId: insuranceParamsId!,
                              }).catch(() => {
                                alert('Při zpracování požadavku došlo k chybě')
                                setIsGoingBack(false)
                              })
                            }}
                          >
                            {translate('back', 'Zpět')}
                          </Button>
                        </Flex>
                      </Stack>
                    </Heading>
                  </Grid>
                </Container>
              </Section>
            )}
            {!isContracted && <LeasingPageComponent />}
          </OffersVehicleProvider>
        </WizzardHeaderProvider>
      )}
    </>
  )
}

export const LeasingPage = LeasingPageWrapper
